module.exports = __webpack_public_path__ + "img/60_1.518d107d.png";